import classNames from 'clsx';
import React from 'react';

import Icons from '@swf/generated/sports-icons';
import type { IconName } from '@swf/sports/types/icon';

import styles from './Icon.scss';

export interface Props extends Omit<React.SVGProps<SVGSVGElement>, 'name'> {
  className?: string;
  name: IconName;
  label?: string;
  size?: 'xs' | 'sm' | 'lg' | 'xl' | 'x1' | 'x2' | 'x2.5' | 'x3' | 'x4' | 'x5';
  testId?: `${string}-icon`;
}

const Icon: React.FC<Props> = ({
  name,
  className,
  size,
  label,
  testId = 'sports-icon',
  ...rest
}) => {
  const SvgComponent = Icons[name];
  const baseProps = {
    'data-testid': testId,
    'data-test': `${name}-icon`,
    'aria-label': label,
    'aria-hidden': !label ? true : undefined,
    role: label ? 'img' : undefined,
    className: classNames(
      styles.icon,
      size && styles[size.replace('.', '') as keyof typeof styles],
      className
    ),
    ...rest
  };

  return <SvgComponent {...baseProps} />;
};

export { Icon, Icons };
